import React from 'react';
import { CTABlock } from './CTABlock';
export function HeroSection() {
  return <section className="bg-forest-900 text-forest-50 pt-16 pb-16 px-4 md:pt-20 md:pb-24" data-id="element-68">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-69">
        <div className="space-y-8 text-center md:text-left" data-id="element-70">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-71">
            Reducí tu panza inflada y recuperá control en 14 días...{' '}
            <span className="text-gold-400 block mt-2" data-id="element-72">
              comiendo en cualquier feria o super de Argentina.
            </span>
          </h1>

          {/* Mockup - visible only on mobile, between title and subtitle */}
          <div className="flex justify-center md:hidden" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/x98rBG67dLThdQ4p2Ybbqw/Mockup_(4).png" alt="Protocolo Rescate SIBO Mockup" className="w-full max-w-sm drop-shadow-2xl animate-fade-in-up" data-id="element-74" />
          </div>

          <p className="text-2xl font-bold text-white leading-relaxed" data-id="element-75">
            Sin antibióticos. Sin dietas imposibles. Sin adivinar qué te hace
            mal.
          </p>

          <p className="text-lg md:text-xl text-forest-50/90 leading-relaxed italic" data-id="element-76">
            El primer protocolo de nutrición vegetal funcional diseñado para la
            mujer argentina con síntomas compatibles con SIBO.
          </p>

          <div className="pt-4 flex justify-center md:justify-start" data-id="element-77">
            <CTABlock className="w-full md:w-auto text-lg" data-id="element-78">
              QUIERO EL PROTOCOLO COMPLETO
            </CTABlock>
          </div>
        </div>

        {/* Mockup - visible only on desktop */}
        <div className="hidden md:flex justify-center" data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/x98rBG67dLThdQ4p2Ybbqw/Mockup_(4).png" alt="Protocolo Rescate SIBO Mockup" className="w-full max-w-full drop-shadow-2xl animate-fade-in-up" data-id="element-80" />
        </div>
      </div>
    </section>;
}